import { TDocumentDefinitions } from "pdfmake/interfaces";
import pdfMake from "pdfmake/build/pdfmake";
import { ITrainingRequest } from "../../../shared/models/TrainingRequestModel";
import { IUser } from "../../../shared/models/User";
import { Landscape } from "@mui/icons-material";
import { getBase64ImageFromURL } from "../../../shared/functions/scorecard-pdf/ImageDefinition";

// PDF Generation Function (No hooks used here)
export const GenerateTrainingRequestsPDF = async (
    title: string,
    trainingRequests: ITrainingRequest[],
    users: IUser[],
    departments: any[]
) => {
    const now = Date.now();
    const logo = await getBase64ImageFromURL(`${process.env.PUBLIC_URL}/logo.png`);

    // Utility functions
    const getUserName = (uid: string): string => {
        const user = users.find((user) => user.uid === uid);
        return user ? user.displayName || "Unknown User" : "Unknown User";
    };

    const getDepartmentName = (departmentId: string) => {
        const department = departments.find(
            (dept) => dept.asJson.id === departmentId
        );
        return department ? department.asJson.name : "Unknown Department";
    };

    const getName = (uid: string): string => {
        const currentUser = users.find((user) => user.uid === uid);
        return currentUser?.displayName || "Unknown Supervisor";
    };

    try {
        const documentDefinition: TDocumentDefinitions = {
            pageOrientation: 'landscape', 
            content: [
                {
                    text: `\n\ ${title.toUpperCase()}`,
                    fontSize: 8,
                    bold: true,
                    alignment: "center",
                },
                {
                    image: `${logo}`,
                    fit: [100, 100],
                    margin: [0, -50, 0, 0],
                    alignment: "left",
                  },
                {
                    text: "_______________________________________________________________________________________________________________________________________________",
                },
                {
                    style: "tableExample",
                    table: {
                        // Define specific widths for each column
                        widths: [30, 50, 50, 50, 50, 50, 30, 50, 50, 50, 50, 50, 50, 60],
                        body: [
                            [
                                { text: "User", style: "tableHeader" },
                                { text: "Course Name", style: "tableHeader" },
                                { text: "Start Date", style: "tableHeader" },
                                { text: "End Date", style: "tableHeader" },
                                { text: "Status", style: "tableHeader" },
                                { text: "Institution", style: "tableHeader" },
                                { text: "Comments", style: "tableHeader" },
                                { text: "Email", style: "tableHeader" },
                                { text: "Department", style: "tableHeader" },
                                { text: "Phone Number", style: "tableHeader" },
                                { text: "Supervisor", style: "tableHeader" },
                                { text: "Duration", style: "tableHeader" },
                                { text: "Purpose", style: "tableHeader" },
                                { text: "Date Requested", style: "tableHeader" },
                            ],
                            ...trainingRequests.map((request) => [
                                { text: getUserName(request.uid), noWrap: false, margin: [0, 2], alignment: 'left' },
                                { text: request.courseName, noWrap: false, margin: [0, 2], alignment: 'left' },
                                { text: new Date(request.startDate).toLocaleDateString(), noWrap: false, margin: [0, 2] },
                                { text: new Date(request.endDate).toLocaleDateString(), noWrap: false, margin: [0, 2] },
                                { text: request.status, noWrap: false, margin: [0, 2] },
                                { text: request.institution, noWrap: false, margin: [0, 2] },
                                { text: request.comments, noWrap: false, margin: [0, 2] },
                                { text: request.email, noWrap: false, margin: [0, 2] },
                                { text: getDepartmentName(request.department), noWrap: false, margin: [0, 2] },
                                { text: request.phoneNumber, noWrap: false, margin: [0, 2] },
                                { text: getName(request.supervisor), noWrap: false, margin: [0, 2] },
                                { text: request.duration, noWrap: false, margin: [0, 2] },
                                { text: request.purpose, noWrap: false, margin: [0, 2] },
                                { text: new Date(request.dateRequested).toLocaleDateString(), noWrap: false, margin: [0, 2] },
                            ]),
                        ],
                    },
                },
                {
                    text: `Date/Time Exported: ${new Date(now).toISOString()}`,
                    fontSize: 6,
                    bold: false,
                    margin: [0, 10, 0, 10],
                },
            ],
            styles: {
                tableHeader: {
                    bold: true,
                    fontSize: 9,
                    color: "black",
                },
                tableExample: {
                    margin: [0, 5, 0, 15],
                    fontSize: 8, // Reduced font size to fit more content
                },
            },
            pageMargins: [10, 10, 10, 10], // Adjusted margins to fit content
        };

        // Create and download PDF
        pdfMake
            .createPdf(documentDefinition)
            .download(`${title} ${new Date(now).toISOString()}.pdf`);
    } catch (error) {
        console.error("errorPdf: ", error);
    }
};
